/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createGame = /* GraphQL */ `
  mutation CreateGame(
    $input: CreateGameInput!
    $condition: ModelGameConditionInput
  ) {
    createGame(input: $input, condition: $condition) {
      id
      title
      description
      cards {
        id
        tag
        faceUpString
        faceDownString
      }
      characters {
        id
        name
      }
      fieldTags
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateGame = /* GraphQL */ `
  mutation UpdateGame(
    $input: UpdateGameInput!
    $condition: ModelGameConditionInput
  ) {
    updateGame(input: $input, condition: $condition) {
      id
      title
      description
      cards {
        id
        tag
        faceUpString
        faceDownString
      }
      characters {
        id
        name
      }
      fieldTags
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteGame = /* GraphQL */ `
  mutation DeleteGame(
    $input: DeleteGameInput!
    $condition: ModelGameConditionInput
  ) {
    deleteGame(input: $input, condition: $condition) {
      id
      title
      description
      cards {
        id
        tag
        faceUpString
        faceDownString
      }
      characters {
        id
        name
      }
      fieldTags
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createRoom = /* GraphQL */ `
  mutation CreateRoom(
    $input: CreateRoomInput!
    $condition: ModelRoomConditionInput
  ) {
    createRoom(input: $input, condition: $condition) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      game {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateRoom = /* GraphQL */ `
  mutation UpdateRoom(
    $input: UpdateRoomInput!
    $condition: ModelRoomConditionInput
  ) {
    updateRoom(input: $input, condition: $condition) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      owner
      updatedAt
    }
  }
`;
export const deleteRoom = /* GraphQL */ `
  mutation DeleteRoom(
    $input: DeleteRoomInput!
    $condition: ModelRoomConditionInput
  ) {
    deleteRoom(input: $input, condition: $condition) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      game {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createGuest = /* GraphQL */ `
  mutation CreateGuest(
    $input: CreateGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    createGuest(input: $input, condition: $condition) {
      id
      roomId
      userName
      name
      createdAt
      updatedAt
    }
  }
`;
export const updateGuest = /* GraphQL */ `
  mutation UpdateGuest(
    $input: UpdateGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    updateGuest(input: $input, condition: $condition) {
      id
      roomId
      userName
      name
      createdAt
      updatedAt
    }
  }
`;
export const deleteGuest = /* GraphQL */ `
  mutation DeleteGuest(
    $input: DeleteGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    deleteGuest(input: $input, condition: $condition) {
      id
      roomId
      userName
      name
      createdAt
      updatedAt
    }
  }
`;
export const createRequest = /* GraphQL */ `
  mutation CreateRequest(
    $input: CreateRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    createRequest(input: $input, condition: $condition) {
      id
      roomId
      userName
      name
      isAccept
      createdAt
      updatedAt
    }
  }
`;
export const updateRequest = /* GraphQL */ `
  mutation UpdateRequest(
    $input: UpdateRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    updateRequest(input: $input, condition: $condition) {
      id
      roomId
      userName
      name
      isAccept
      createdAt
      updatedAt
    }
  }
`;
export const deleteRequest = /* GraphQL */ `
  mutation DeleteRequest(
    $input: DeleteRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    deleteRequest(input: $input, condition: $condition) {
      id
      roomId
      userName
      name
      isAccept
      createdAt
      updatedAt
    }
  }
`;
